import { SystemProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import { Typography, Link } from '@mui/material';
import React, { FC, useMemo } from 'react';
import { TournamentPlayerEntity } from 'app/interfaces/entity';

type ConnectionLabelProps = {
  player: TournamentPlayerEntity;
} & SystemProps<Theme>;

export const ConnectionLabel: FC<ConnectionLabelProps> = ({ player }) => {
  const connection = useMemo(() => {
    if (!player.user.connections?.length) {
      return null;
    }

    return player.user.connections[0] as unknown as Record<string, string>;
  }, [player]);

  if (!connection) {
    return null;
  }

  return (
    <Typography variant="subtitle2" sx={{ textTransform: 'initial' }}>
      Playing as{' '}
      <Link href={connection.url} target="_blank">
        {connection.username}
      </Link>
    </Typography>
  );
};
